import { render, staticRenderFns } from "./text-only-message.vue?vue&type=template&id=65be743f"
import script from "./text-only-message.vue?vue&type=script&lang=js"
export * from "./text-only-message.vue?vue&type=script&lang=js"
import style0 from "./text-only-message.vue?vue&type=style&index=0&id=65be743f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports